// Tipos de reportes (impeachment) para el sistema de denuncias
// Adaptado desde amarsi-app/src/constants/humanQualities.js

export const impeachment = [
  {
    title: 'Odio',
    desc: 'Palabras ofensivas, estereotipos racistas o sexistas, deshumanización, incitación al miedo o la discriminación, referencias a discursos de odio, símbolos y logotipos relacionados con discursos de odio',
  },
  {
    title: 'Abuso y acoso',
    desc: 'Insultos, contenido no deseado de carácter sexual y cosificación explícita, contenido no apto para el ambiente laboral (NSFW) y contenido gráfico no deseado, negación de eventos violentos, acoso dirigido e incitación al acoso',
  },
  {
    title: 'Discurso violento',
    desc: 'Amenazas violentas, deseo de provocar lesiones, glorificación de la violencia, incitación a la violencia, incitación codificada a la violencia',
  },
  {
    title: 'Protección de personas menores de edad',
    desc: 'Explotación sexual infantil, ciberacoso a menores (grooming), abuso físico infantil, usuario menor de edad',
  },
  {
    title: 'Privacidad',
    desc: 'Distribución de información privada, amenazas de distribuir/exponer información privada, distribución no consensuada de imágenes íntimas, distribución de imágenes de mí que no deseo que estén en la plataforma',
  },
  {
    title: 'Spam',
    desc: 'Llevar a cabo estafas financieras, postear enlaces maliciosos, usar hashtags de forma indebida, falsificar interacciones, enviar respuestas, reposts o Mensajes Directos repetitivos.',
  },
  {
    title: 'Suicidio o autolesiones',
    desc: 'Fomentar o promover las autolesiones, o bien proporcionar instrucciones o compartir estrategias para autolesionarse.',
  },
  {
    title: 'Contenido delicado o perturbador',
    desc: 'Graphic Content, Gratutitous Gore, Adult Nudity & Sexual Behavior, Violent Sexual Conduct, Bestiality & Necrophilia, Media depicting a deceased individual',
  },
  {
    title: 'Identidades engañosas',
    desc: 'Suplantación de identidad, parodias/cuentas de fans que no cumplen las normas',
  },
  {
    title: 'Violencia o de incitación al odio',
    desc: 'Extremismo violento y terrorismo, grupos y redes de odio.',
  }
];
